<template>
  <el-config-provider namespace="ui">

    <!-- <el-button type="info">Cash out</el-button>
    <el-button type="primary">Cash out</el-button>
    <el-button>Cash out</el-button>
    <el-button type="text">Processing</el-button> -->
    <mobile-header v-if="store.is_mobile && !isRegister" />
    <router-view v-if="!me_loading" />
    <global-drawer ref="globalDrawer" />
    <tutorial-popup />
    <share-popup />
  </el-config-provider>
</template>

<script setup>
import { watch, onMounted, onBeforeUnmount, ref, computed } from 'vue';
import router from './router';
import { useGlobalStore } from './stores/GlobalStore';
import { useRoute } from 'vue-router';
import MobileHeader from '@/components/MobileHeader.vue';
import GlobalDrawer from '@shared/components/GlobalDrawer.vue';
import SharePopup from '@shared/components/ui/SharePopup.vue';
import TutorialPopup from '@shared/components/ui/TutorialPopup.vue';
import EventBus from '@shared/utils/EventBus';
import { initPendo } from '@/utils/Pendo';

const route = useRoute();
const store = useGlobalStore();
const me_loading = ref(true);
const is_login = ref(false);

const isRegister = computed(() => {
  let rou = router.currentRoute.value.meta;
  return rou.login || rou.heading === 'Register' || rou.heading === 'Login';
});

// watch router name
const pageHeading = computed(() => router.currentRoute.value.meta.heading || '');
watch(pageHeading, (heading) => {
  document.body.className = `page-${router.currentRoute.value.name}`;

  // scroll to top
  window.scrollTo(0, 0);
});

store.setIsMobile(window.innerWidth < 728);
store.setIsTablet(window.innerWidth < 1180);

let resizeTimeout;
const handleResize = () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    const vh = window.innerHeight * 0.01; // 1vh
    document.documentElement.style.setProperty('--real-vh', `${vh}px`);

    const newIsMobile = window.innerWidth < 728;
    const newIsTablet = window.innerWidth < 1180;

    if (store.is_mobile !== newIsMobile) {
      store.setIsMobile(newIsMobile);
    }
    if (store.is_tablet !== newIsTablet) {
      store.setIsTablet(newIsTablet);
    }
  }, 200); // 優化resize事件
};

const checkLogin = () => {
  is_login.value = window.localStorage && window.localStorage.getItem('token');
  let isRegisterGetSocial = window.localStorage.getItem('REATOR_PROTAL_register_go_out');
  let cjLoginKey = window.localStorage.getItem('CREATOR_PROTAL_cj_login_key_v2');
  const isPublicPage = ['/pages/motom-terms-of-use', '/pages/motom-privacy-policy'].includes(window.location.pathname);

  if( cjLoginKey || window.location.href.includes('register') || isPublicPage ){
    me_loading.value = false;
    return;
  }

  if (is_login.value !== null && !isRegisterGetSocial ) {
    store
      .getUserMe()
      .then((user) => {
        store.user = user;
        // user_status = 100 email verified
        // if user_status is not 100, redirect to login page
        if (route.name === undefined) {
          me_loading.value = false;
          return;
        }

        if (window.location.href.includes('register') && route.name !== 'register') {
          window.location.href = '/register';
          me_loading.value = false;
          return;
        }

        if (
          store.user.user_status !== 100 &&
          route.name !== 'register' &&
          !route.meta.login &&
          !window.location.href.includes('register')
        ) {
          store.clearToken();
          window.location.href = '/login';
        } else if (route.meta.login) {
          window.location.href = '/';
        }
        if (
          store.user.user_status === 100 &&
          route.name !== 'register' &&
          !route.meta.login &&
          !window.location.href.includes('register') &&
          !window.location.href.includes('login')
        ) {
          initPendo(store.user);
        }

        setTimeout(() => {
          me_loading.value = false;
        }, 100);
      })
      .catch((err) => {
        me_loading.value = false;
        if (route.name !== 'invite' && route.name !== 'register' && route.name !== undefined) {
          window.location.href = '/login';
        }
      });
  } else {
    me_loading.value = false;
  }
};

const openGlobalHelp=()=>{
  window.open('https://cjaffiliate.my.site.com/publisher/s/contactsupport', '_blank');
}

onMounted(() => {
  checkLogin();
  handleResize();
  EventBus.on('open-global-help', openGlobalHelp);
  window.addEventListener('resize', handleResize);
  console.log('process.env.NODE_ENV',process.env.NODE_ENV)
  console.log(process.env);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
  EventBus.off('open-global-help', openGlobalHelp);
});
</script>

<style lang="scss">
@import '@/assets/scss/element.scss';
@import '@/assets/scss/fonts.scss';
@import '@/assets/scss/reset.scss';
@import '@/assets/scss/register.scss';

:root {
  --font: 'Inter', sans-serif;
  --font-demi: 'Inter', sans-serif;
  --font-med: 'Inter', sans-serif;

  /* Franklin Gothic Book */
  --book-10: 400 10px/14px var(--font);
  --book-12: 400 12px/16px var(--font);
  --book-14: 400 14px/18px var(--font);
  --book-16: 400 16px/20px var(--font);
  --book-18: 400 18px/22px var(--font);
  --book-20: 400 20px/24px var(--font);
  --book-22: 400 22px/26px var(--font);

  /* Franklin Gothic Medium */
  --medium-10: 500 10px/14px var(--font-med);
  --medium-12: 500 12px/16px var(--font-med);
  --medium-14: 500 14px/18px var(--font-med);
  --medium-16: 500 16px/20px var(--font-med);
  --medium-18: 500 18px/22px var(--font-med);
  --medium-20: 500 20px/24px var(--font-med);
  --medium-22: 500 22px/26px var(--font-med);
  --medium-24: 500 24px/28px var(--font-med);
  --medium-26: 500 26px/30px var(--font-med);
  --medium-28: 500 28px/32px var(--font-med);
  --medium-30: 500 30px/34px var(--font-med);
  --medium-32: 500 32px/36px var(--font-med);
  --medium-34: 500 34px/38px var(--font-med);
  --medium-36: 500 36px/40px var(--font-med);

  /* Franklin Gothic Demi */
  --demi-10: 500 10px/14px var(--font-demi);
  --demi-12: 500 12px/16px var(--font-demi);
  --demi-14: 500 14px/18px var(--font-demi);
  --demi-16: 500 16px/20px var(--font-demi);
  --demi-18: 500 18px/22px var(--font-demi);
  --demi-20: 500 20px/24px var(--font-demi);
  --demi-22: 500 22px/26px var(--font-demi);
  --demi-24: 500 24px/28px var(--font-demi);
  --demi-26: 500 26px/30px var(--font-demi);
  --demi-28: 500 28px/32px var(--font-demi);
  --demi-30: 500 30px/34px var(--font-demi);
  --demi-32: 500 32px/36px var(--font-demi);
  --demi-34: 500 34px/38px var(--font-demi);
  --demi-36: 500 36px/40px var(--font-demi);

  // --PB-100: #c92d3b;
  // --PB-80: lighten(#c92d3b, 20%);
  // --PB-60: lighten(#c92d3b, 40%);
  // --PB-40: lighten(#c92d3b, 60%);
  // --PB-20: lighten(#c92d3b, 80%);
  --PB-100: #111827;
  --PB-80: lighten(#111827, 20%);
  --PB-60: lighten(#111827, 40%);
  --PB-40: lighten(#111827, 60%);
  --PB-20: lighten(#111827, 80%);


  --Brand-primary: #111827;
  --Brand-primary-30: #334155;
  --Brand-primary-60: #0F172A;
  --Brand-primary-80: #111827;
  --Brand-secondary: #1D4ED8;
  --Brand-orange: #f2827f;
  --Brand-purple: #7e86bf;
  --Brand-grey: #eeeeee;
  --Brand-hover: #fafafa;
  --Brand-gray: #999999; 
  --Brand-dark-gray: #656565;

  --Red-10: #ffebeb;
  --Red-30: #f22028;
  --Yellow-10: #fff5d5;
  --Yellow-30: #FFC107;
  --Blue-10: #d3e1fe;
  --Blue-30: #1A6FBA;
  --Green-10: #e8f8f2;
  --Green-30: #00A870;
  --Blue-hover: #155995;

  --Black-100: #000000;
  --Black-90: #111827;
  --Black-80: #1F2937;
  --Black-70: #374151;
  --Black-60: #4B5563;
  --Black-50: #6B7280;
  --Black-40: #9CA3AF;
  --Black-30: #D1D5DB;
  --Black-20: #E5E7EB;
  --Black-10: #F3F4F6;
  --Black-05: #F9FAFB;
  --Black-00: #FFFFFF;

  --Black-100-rgba: 0, 0, 0;
  --Black-90-rgba: 51, 51, 51;
  --Black-60-rgba: 130, 130, 130;
  --Black-00-rgba: 255, 255, 255;

  --Neu-00: #ffffff;
  --Neu-10: #f6f8fc;
  --Neu-20: #f1f4f9;
  --Neu-30: #e2e8f0;
  --Neu-40: #cbd4e1;
  --Neu-50: #94a3b8;
  --Neu-60: #64748b;
  --Neu-70: #475569;
  --Neu-80: #27364b;
  --Neu-90: #1e2a3b;
  --Neu-100: #0f1a2a;

  --Spotify: #1db954;
  --Facebook-new: #1877f2;
  --Facebook-old: #3b5998;
  --Insta: #c32aa3;
  --Pinterest: #e60023;
  --Twitter: #1da1f2;
  --X-twitter: #000000;
  --YouTube: #ff0000;
  --Snapchat: #fffc00;
  --Google: #0f9d58;
  --Linktree: #3ddc84;
  --Apple-iOS: #8e8e93;
  --Win: #0078d4;
  --TikTok-Pink: #ee1d52;
  --TikTok-Blue: #69c9d0;
  --TikTok-dark: #010101;

  --Text-brand: var(--Brand-primary-80);
  --Text-primary: var(--Black-80);
  --Text-secondary: var(--Black-70);
  --Text-default: var(--Black-50);
  --Text-disabled: var(--Black-40);
  --Text-invert: var(--Black-00);
  --Text-danger: var(--Red-30);
  --Text-warning: var(--Red-30);
  --Text-safe: var(--Green-30);
  --Text-link: var(--Blue-30);

  --Border-primary: var(--Black-40);
  --Border-secondary: var(--Black-50);
  --Border-dark: var(--Black-100);
  --Border-light: var(--Black-00);
  --Border-default: var(--Black-30);
  --Border-hover: var(--Black-40);
  --Border-disable: var(--Black-30);
  --Border-neu: var(--Black-30);
  --Border-danger: var(--Red-30);
  --Border-Warning: var(--Yellow-30);
  --Border-safe: var(--Green-30);
  --Border-brand: var(--Brand-primary);

  --Surface-primary: var(--PB-100);
  --Surface-primary-hover: var(--Neu-70);
  --Surface-secondary: var(--Brand-orange);
  --Surface-dark: var(--Black-90);
  --Surface-light: var(--Black-00);
  --Surface-neu: var(--Neu-30);
  --Surface-alert: var(--Red-30);
  --Surface-default: var(--Black-20);
  --Surface-hover: var(--Black-30);
  --Surface-disable: var(--Black-40);
  --Surface-tertiary-selected: var(--Neu-20);
  --Surface-danger: var(--Red-10);
  --Surface-safe: var(--Green-10);
  --Surface-warn: var(--Yellow-10);
  --Surface-normal: var(--Blue-10);

  --Bg-dark: var(--Black-90);
  --Bg-light: var(--Black-00);
  --Bg-01: var(--Black-00);
  --Bg-02: var(--Black-05);
  --Bg-03: var(--Black-10);

  --bot-1dp: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
  --bot-2dp: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  --bot-4dp: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  --bot-6dp: 0px 6px 8px 0px rgba(0, 0, 0, 0.1);

  --top-1dp: 0px -1px 2px 0px rgba(0, 0, 0, 0.1);
  --top-2dp: 0px -2px 4px 0px rgba(0, 0, 0, 0.1);
  --top-4dp: 0px -4px 8px 0px rgba(0, 0, 0, 0.1);
  --top-6dp: 0px -6px 8px 0px rgba(0, 0, 0, 0.1);

  --right-1dp: 1px 0px 2px 0px rgba(0, 0, 0, 0.1);
  --right-2dp: 2px 0px 4px 0px rgba(0, 0, 0, 0.1);
  --right-4dp: 4px 0px 8px 0px rgba(0, 0, 0, 0.1);
  --right-6dp: 6px 0px 8px 0px rgba(0, 0, 0, 0.1);

  --left-1dp: -1px 0px 2px 0px rgba(0, 0, 0, 0.1);
  --left-2dp: -2px 0px 4px 0px rgba(0, 0, 0, 0.1);
  --left-4dp: -4px 0px 8px 0px rgba(0, 0, 0, 0.1);
  --left-6dp: -6px 0px 8px 0px rgba(0, 0, 0, 0.1);

  --card: 0px 0 2px 1px rgba(0, 0, 0, 0.1);
  --pop-medium: 2px 4px 30px 1px rgba(0, 0, 0, 0.15);
  --pop-light: 2px 4px 20px 0px rgba(0, 0, 0, 0.1);
  --neno-01: 0px 4px 8px 0px rgba(241, 101, 41, 0.35), 1px 2px 4px 0px rgba(249, 163, 38, 0.32);

  --mbg-bttb: 348.82deg, var(--Red-30) 8.25%, var(--Yellow-30) 91.52%;
  --mbg-bttf: 102.8deg, var(--Red-30) 6.94%, var(--Yellow-30) 91.73%;
  --mbg-bttl: 168.82deg, var(--Red-30) 11.16%, var(--Yellow-30) 91.53%;

  --font-xxxl: 32px;
  --font-xxl: 24px;
  --font-xl: 22px;
  --font-l: 20px;
  --font-md: 18px;
  --font-m: 16px;
  --font-s: 14px;
  --font-xs: 12px;
  --font-xxs: 10px;

  --font-lh-xxxl: 34px;
  --font-lh-xxl: 26px;
  --font-lh-xl: 24px;
  --font-lh-l: 22px;
  --font-lh-md: 20px;
  --font-lh-m: 18px;
  --font-lh-s: 16px;
  --font-lh-xs: 14px;
  --font-lh-xxs: 12px;

  --font-semi: 600;
  --font-medium: 500;
  --font-regular: 400;
  --font-light: 300;

  --spacing-01: 2px;
  --spacing-02: 4px;
  --spacing-03: 8px;
  --spacing-04: 12px;
  --spacing-05: 16px;
  --spacing-06: 24px;
  --spacing-07: 32px;
  --spacing-08: 36px;
  --spacing-09: 40px;
  --spacing-10: 48px;
  --spacing-11: 64px;

  --register_max_width: 550px;
  --radius: 10px;
  --radius-small: 2px;
  --radius-medium: 6px;
  --radius-big: 16px;
  --radius-round: 50%;
  --radius-large: 12px;

  --mobile-header-height: 40px;
  --mobile-footer-height: 58px;
  --analytics-mob-padding: 12px;

  --dialog-max-width: 616px;
  --max-width: 1280px;
  --padding: max(24px, 3vw);

  @media screen and (max-width: $mobile_size) {
    --padding: 16px;
  }
}

html {
  -webkit-overflow-scrolling: touch;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  background-color: var(--Bg-02);
}

body {
  font: var(--book-14);

  /* Font smoothing */
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  font-feature-settings: "ss02";
  background-color: var(--Bg-02);
  
  
  &.disabled-scroll {
    overflow: hidden !important;
  }
}

* {
  box-sizing: border-box;
}

body .product-search-popup .search-popup-input {
  background-color: var(--Bg-03);
}

#app {
  min-height: 100vh;

  .w-100 {
    width: 100%;
  }

  .post-detail-drawer .info {
    background-color: transparent;
    padding-top: 16px;
  }

  .login-container {
    padding: 0 !important;

    @media (max-width: $mobile_size) {
      display: flex !important;
    }

    .ui-main {
      background: var(--Bg-01);
    }
  }

  .sortlink-checkbox-box {
    .ui-checkbox {
      height: 16px;
      margin-top: 4px;

      .svg-icon {
        width: 16px;
        height: 16px;
      }
    }

    .ui-tooltip__trigger {
      display: grid;
      grid-template-columns: auto 1fr;
      gap: 4px;
    }
  }

  .report-grid-data {
    @media (min-width: $mobile_size) {
      display: grid;
      width: calc(100% - 4px);
      // border: solid 1px var(--Black-20);

      .grid-box {
        border-right: solid 1px var(--Black-20);
        padding: 8px 16px; //24px 16px;

        .value {
          font: var(--demi-24);
        }

        .label-big {
          font: var(--medium-16);
        }

        // &:last-child {
        //   border-right: none;
        // }
      }
    }

    .grid-box {
      .value {
        color: var(--Text-primary);

        svg {
          margin-left: 10px;
          width: 10px;
          height: 10px;
          fill: var(--Green-30);

          &.down {
            fill: var(--Red-30);
            transform: rotate(90deg);
          }
        }
      }

      .label-big {
        color: var(--Text-secondary);
      }
    }
  }
}

svg:focus {
  outline: none !important;
}

a {
  color: #2563EB;
  text-decoration: none;
  cursor: pointer;

  &:hover,
  &:active {
    color: var(--Brand-secondary);
    text-decoration: none;
  }
}

.main-content {
  height: 100vh;
}

.custom-select-picker {
  //transform: translateY(-12px);
  .ui-popper__arrow {
    display: none;
  }
}

.page-header {
  padding-right: var(--padding);
  padding-left: var(--padding);
  border-bottom: 1px solid var(--Black-30);
  background-color: var(--Bg-01);
  min-height: 63px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 10;

  .page-title {
    flex: 1;
    color: var(--Text-primary);
    font: var(--demi-30);
  }

  .actions-wrap {
    display: flex;
    align-items: center;
    gap: 16px;
  }
}

.alert-modal {
  padding: 24px;

  i {
    display: block;
    height: 68px;
    width: 68px;
    margin: 0 auto 24px;
    color: var(--Blue-30);

    svg {
      display: block;
      height: 100%;
      width: 100%;
    }
  }

  h2 {
    font: var(--medium-18);
    text-align: center;
    margin-bottom: 24px;
    color: var(--Text-primary);
  }

  .ui-button {
    margin: 0 auto;
    min-width: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.alert-modal-2 {
  .content {
    text-align: left;

    h2 {
      font: var(--medium-18);
      text-align: left;
      margin-bottom: 16px;
    }

    p {
      padding: 0 0 36px;
      text-align: left;
    }

    & + footer {
      display: flex;

      .ui-button--text {
        min-width: 130px;
        margin-right: 16px;
        text-align: center;
      }

      .ui-button--primary {
        flex: 1;
      }
    }
  }
}

#app {
  min-height: 100vh;

  .w-100 {
    width: 100%;
  }

  .date-picker .date-picker-wrap:hover {
    background-color: var(--Bg-02);
    border-color: var(--Black-30);
  }

  .login-container {
    padding: 0 !important;

    @media (max-width: $mobile_size) {
      display: flex !important;
    }

    .ui-main {
      background: var(--Bg-01);
    }
  }

  .brand-content-wrap {
    padding: 0;
    margin-top: 0;
    margin-bottom: 0;
    background-color: transparent;

    & > .desc {
      font: var(--book-14);
      color: var(--Text-default);
      margin: 8px 0 16px 0;

      @media (max-width: $mobile_size) {
        margin: 16px 16px 0;
      }
    }

    .brand-content,
    .head-info {
      padding: 16px;
      border-radius: var(--radius);
      border: 1px solid var(--Black-20);
      background-color: var(--Bg-01);
      margin: 24px 0;
    }

    .head-info {
      .social-conten-block {
        padding: 0;
        margin: 0;

        &:first-child {
          margin-bottom: 24px;
        }

        .content-title {
          margin-bottom: 16px;

          h2 {
            font-size: 18px;
            gap: 8px;
            color: var(--Text-primary);

            svg {
              height: 20px;
              width: 20px;
            }
          }
        }

        .content-block {
          display: block;

          & + .content-block,
          & + .content-block + .content-block {
            margin-top: 16px;
          }

          h4 {
            font: var(--medium-16);
            margin-bottom: 8px;
            color: var(--Text-primary);
          }

          & > .p {
            p {
             display: none;
            }
          }

          .type-box {
            border-radius: var(--radius);
            background-color: var(--Bg-03);

            @media (max-width: $mobile_size) {
              grid-template-columns: 1fr 1fr 1fr;
            }

            .type {
              border: none;
              background-color: transparent;
              padding: 16px;
              display: flex;
              flex-direction: column;
              gap: 6px;

              .text {
                font: var(--book-14);
                color: var(--Text-default);
                width: 100%;
                order: 1;
              }

              .value {
                font: var(--medium-24);
                color: var(--Text-primary);
                width: 100%;
                order: 2;
                color: var(--Text-primary);
              }
            }
          }
        }
      }
    }

    .brand-content {
      .template-title {
        color: var(--Text-primary);
        font-size: 18px;
        margin: 0;
      }

      .ui-radio-group {
        margin: 16px 0 0;
      }
    }
  }

  .manage-product-item .bot > span, .manage-product-item .bot .price {
    opacity: 0;
    pointer-events: none;
  }

  .products-drawer {
    .ui-drawer__body {
      background-color: var(--Bg-02);
    }

    .sortlink-select {
      display: none;
    }

    .product-info-box {
      border-radius: var(--radius);
      border: 1px solid var(--Border-default);

      .product-info .product-data-box {
        grid-template-columns: repeat(5, 1fr);

        .product-data {
          &:nth-child(1) {
            order: 1;
          }

          &:nth-child(2) {
            order: 3;
          }

          &:nth-child(3) {
            order: 2;
          }

          &:nth-child(4) {
            order: 4;
          }

          &:last-child {
            display: none;
          }
        }
      }
    }

    
  }

  .analytics-page .grid-box .desc-box {
    display: none;
  }

  .post-item {
    .date {
      color: var(--Text-secondary);
      font: var(--book-12);
      
      span {
        display: none;
      }
    }

    .hr {
      display: none;
    }

    .img-bagage {
      background-color: #333;
      border-radius: var(--radius-medium);
      border: none;
      right: auto;
      left: 50%;
      transform: translateX(-50%);
      --ui-tag-font-size: 10px;
      --ui-tag-text-color: var(--Text-invert);
    }

    .card > div:not(.date):not(.hr) {
      display: flex;
      flex-wrap: wrap;

      .it-vi {
        width: 50%;
        display: block;
        font: var(--book-14);
        color: var(--Text-primary);

        span {
          display: block;
          font: var(--book-12);
          color: var(--Text-default);
          margin: 3px 0 0 0;
        }
      }

      .icon-box {
        width: 100%;
        margin: 4px 0 6px;

        .icon-item {
          font: var(--book-12);
          color: var(--Black-60);

          svg {
            fill: var(--Black-60);
            height: 12px;
            width: 12px;
          }
        }
      }
    }
  }
  
  .sortlink-checkbox-box {
    .ui-checkbox {
      height: 16px;
      margin-top: 4px;

      .svg-icon {
        width: 16px;
        height: 16px;
      }
    }

    .ui-tooltip__trigger {
      display: grid;
      grid-template-columns: auto 1fr;
      gap: 4px;
    }
  }

  .report-grid-data {
    display: flex;
    gap: 16px;

    .grid-box {
      border: solid 1px var(--Border-default);
      padding: 16px;
      flex: 1;
      border-radius: var(--radius);

      .value {
        font: var(--medium-24);
        color: var(--Text-primary);
        display: block;
        margin: 0 0 2px;

        svg {
          margin-left: 8px;
          width: 11px;
          height: 11px;
          fill: var(--Green-30);
          position: relative;
          top: -2px;

          &.down {
            fill: var(--Red-30);
            transform: rotate(90deg);
          }
        }
      }

      .label-big {
        font: var(--book-14);
        color: var(--Text-secondary);
      }
    }

    @media screen and (max-width: $mobile_size) {
      flex-wrap: wrap;
      gap: 12px;

      .grid-box {
        flex: 1 1 calc(50% - 8px);
      }
    }
  }

  .custom-th .ico.sort.asc,
  .custom-th .ico.sort.desc,
  .the-type .value {
    color: var(--Brand-primary);
  }

  .collection-detail-drawer .manage-product-item figure {
    border: none;
  }

  .add-content-drawer .add-content-list li {
    box-shadow: unset;

    &:hover {
      background-color: var(--Black-10);
    }

    span {
      font: var(--book-14);
    }
  }

  .todo-block.todo-block-handle {
    h4 {
      color: var(--Text-primary);
    }

    .ui-button {
      color: var(--Text-invert);
      background-color: var(--Brand-primary);

      &:hover {
        background-color: var(--Brand-primary-30);
      }
    }
  }

  .empty-page-wrap {
    padding: 0;

    .empty-page-header {
      border-bottom: 1px solid var(--Black-30);
      background-color: var(--Bg-01);
      min-height: 63px;
      display: flex;
      align-items: center;
      padding: 0 var(--padding);

      h1 {
        flex: 1;
        color: var(--Text-primary);
        font: var(--demi-30);
        padding: 0;
        margin: 0;
      }
    }
  }

  .add-product-popup .tag-item:hover,
  .add-post-popup .select-list li:hover,
  .manage-page-tools ul li:hover {
    border-color: var(--Black-30);
    background-color: var(--Black-10);
  }

  .ui-loading-mask {
    background-color: transparent;
  }

  .add-product-popup .tag-item .info p {
    color: var(--Text-default);
  }

  .tag-product-drawer .list-box .info-head .filter-wrap {
    padding: 12px;
    border-radius: var(--radius-large);
    background-color: var(--Bg-01);
  }

  .tag-product-item {
    .brand-label {
      font-size: 12px;
      color: var(--Text-primary);
    }

    .product-name {
      margin: 4px 0;
      font: var(--book-16);
      color: var(--Text-primary);
      word-break: break-word;
    }

    .sold-by-label {
      font-size: 12px;
      color: var(--Text-default);
    }

    .bot .price {
      font: var(--book-14);
      color: var(--Text-primary);
    }
  }

  .storefront-summary .chart-box .chart-legend .legend-item  {
    font-weight: normal;

    .legend-color.storefront-color {
      background: var(--Brand-primary);
    }

    .legend-color.shortlink-color {
      background: var(--Brand-secondary);
    }
  }

  .empty-states {
    background-color: var(--Bg-02);
  }

  .add-product-to-collections-drawer .list-wrap,
  .ui-drawer {
    background-color: var(--Bg-02);

    &.products-drawer {
      background-color: var(--Bg-01);
    }
  }

  .tag-product-drawer .content-box.type-url .input-box {
    padding-top: 16px;
  }

  .tag-product-drawer--storefront .tag-product-item .bot .price {
    opacity: 0;
    pointer-events: none;
  }

  .products-template .report-grid-data .grid-box,
  .post-item,
  .doughnut-box {
    border-color: var(--Black-20);
  }

  .post-item .hr {
    background-color: var(--Black-20);
  }

  .custom-th .ico.sort.asc svg,
  .custom-th .ico.sort.asc .svg-icon,
  .custom-th .ico.sort.desc svg,
  .custom-th .ico.sort.desc .svg-icon {
    fill: var(--Brand-primary);
  }

  .ui-navi {
    border-bottom: 1px solid var(--Black-30);
    text-transform: uppercase;

    @media screen and (max-width: $mobile_size) {
      border-bottom: none;
    }

    ul {
      gap: 24px;

      li a {
        color: var(--Black-80);
        align-items: flex-start;
        font-weight: 400;
        height: 32px;
        text-transform: uppercase;
        margin: 0;

        &:hover {
          color: var(--Brand-primary);
        }
      }

      @media screen and (max-width: $mobile_size) {
        gap: 16px;

        li a {
          font-size: 12px;
          height: 24px;
        }
      }
    }
  } 

  .manage-collection-item {
    background-color: var(--Bg-01);
    border-radius: var(--radius);

    figure {
      border-radius: var(--radius) var(--radius) 0 0;
      background-color: var(--Black-20);
    }

    .overlay {
      border-radius: var(--radius) var(--radius) 0 0;
    }

    .bot {
      padding-bottom: 8px;
      padding-left: 12px;
      padding-right: 12px;
    }
  }

  .manage-post-item {
    background-color: var(--Bg-01);
    border-radius: var(--radius);

    figure {
      border-radius: var(--radius) var(--radius) 0 0;
    }

    .overlay {
      border-radius: var(--radius) var(--radius) 0 0;
    }

    .bot {
      padding: 4px 12px 12px;
    }
  }

  .manage-product-item {
    background-color: var(--Bg-01);
    border-radius: var(--radius);

    figure {
      padding-bottom: 110%;
      border-radius: var(--radius) var(--radius) 0 0;
    }

    .overlay {
      border-radius: var(--radius) var(--radius) 0 0;
    }

    .name,
    .sold-by-label,
    .brand-label,
    .bot {
      padding-left: 12px;
      padding-right: 12px;
      font-weight: normal;
    }

    .bot {
      padding-bottom: 8px;

      .bot-flex {
        font-size: 16px;
        color: var(--Text-primary);
      }
    }
  }

  .products-template .products-page-header {
    margin-top: 0;
  }

  .add-product-popup .tag-item .info h3 {
    font-weight: normal;
  }

  .ui-radio-button {
    --ui-color-primary: var(--Brand-primary);
    --ui-border-radius-base: 0;
    --ui-border: none;
    --ui-fill-color-blank: var(--Bg-02);

    &:hover .ui-radio-button__inner {
      background-color: var(--Bg-03);
    }

    &.is-active:hover .ui-radio-button__inner {
      background-color: var(--Brand-primary);
    }
  }

  .ui-radio-button__inner {
    padding-top: 12px;
    padding-bottom: 12px;
  }


  .ui-navi ul li a.router-link-active,
  .ui-navi ul li a.router-link-exact-active,
  .ui-navi ul li a.link-selected,
  .ui-navi .link.router-link-active,
  .ui-navi .link.router-link-exact-active,
  .ui-navi .link.link-selected {
    color: var(--Brand-primary);

    &::before {
      bottom: -1px;
      height: 2px;
      background-color: var(--Brand-primary);;
    }
  }

  .announcements-block .btn-pick {
    border-width: 2px;
  }

  .ui-pagenavi .bar {
    background-color: var(--Black-10);
    border-color: var(--Black-10);
  }

  .message-wrap .message-content .hr-start::after {
    background-color: var(--Black-30);
  }

  @at-root {
    .page-manage #app {
      .mobile-header .center .select-storefront {
        &::before {
          content: 'My storefront';
          font: var(--medium-16);
          color: var(--Text-primary);
        }

        .ui-dropdown {
          display: none;
        }
      }
    }
  }

  .social-drawer {
    time {
      font: var(--book-12);
      color: var(--Text-secondary);
    }

    .social-wrap {
      padding: 0;
      height: calc(100vh - 64px);
      min-height: unset;

      & > header {
        padding: 24px;
        background-color: var(--Bg-01);
      }

      .inner-box-st-box {
        padding: 24px;
        gap: 24px;
        display: flex;
        width: 100%;

        .left-side {
          width: 33.33%;
          max-width: 480px;

          .ui-image {
            display: block;
          }

          figure {
            width: 100%;
          }

          .bottom-line {

            &:nth-child(3) {
              margin-top: 16px;
            }

            span {
              font: var(--book-14);
              color: var(--Text-secondary);
            }

            &.status:after {
              font: var(--book-16);
            }

            time {
              font: var(--book-16);
              color: var(--Text-primary) !important;
            }
          }

          .content-line {
            .text {
              margin-top: 6px;

              h3 {
                font: var(--book-16);
                color: var(--Text-primary);
              }

              a {
                font-size: 14px;
              }
            }

            dl {
              margin-top: 6px;

              dd {
                font: var(--book-16);
                color: var(--Text-primary);
              }
            }
          }
        }

        .content {
          flex: 1;
        }

        @media screen and (max-width: $mobile_size) {
          padding: 16px;
          gap: 16px;
          flex-direction: column;

          .left-side {
            width: 100%;
            margin-bottom: 0;
          }

          .content {
            padding-top: 0;
          }

        } 

        .top {
          h3 {
            font: var(--medium-24);
            color: var(--Text-primary);
          }

          .desc {
            margin-top: 4px;
            color: var(--Text-secondary);
          }
        }

        .info {
          margin: 16px 0;
          padding: 16px;
          border: 1px solid var(--Black-30);
          border-radius: var(--radius);
          background-color: var(--Bg-01);
        }

        .info > ul li {
          border: 1px solid #DBEAFE;
          background-color: #EFF6FF;
          border-radius: var(--radius);
          padding: 16px;
          display: flex;
          flex-direction: column;
          gap: 12px;

          strong {
            font-size: 24px;
            font-weight: 500;
            color: var(--Text-primary);
            order: 2;
          }

          span {
            font-weight: normal;
            font-size: 14px;
            color: var(--Brand-secondary);
            order: 1;
          }
        }

        .storefront-top {
          margin-top: 24px;
        }

        .storefront-info {
          margin: 16px 0;
          padding: 16px;
          border: 1px solid var(--Black-30);
          border-radius: var(--radius);
          background-color: var(--Bg-01);

          .info {
            margin: 0;
            padding: 0;
            border: 0;
            border-radius: unset;
          }

          .title-left {
            h4 {
              font: var(--medium-16);
              color: var(--Text-primary);
            }

            .desc {
              font: var(--book-14);
              color: var(--Text-secondary);

            }

            .date-time {
              font: var(--book-14);
              color: var(--Text-secondary);

              .date-value {
                color: var(--Text-primary);
              }
            }

          }

          .badage-box {
            margin: 16px 0;
          }

          .svg-box {
            color: var(--Text-primary);
            font: var(--book-12);

            svg {
              fill: var(--Text-primary);
            }

            .arrow svg {
              height: 10px;
              width: 10px;
            }
          }
        }
      }

      @media screen and (max-width: $mobile_size) {
        & > header {
          padding: 16px;
        }

        .inner-box-st-box {
          padding: 0;

          .info > ul li {
            padding: 12px;

            strong {
              font-size: 18px;
            }

            span {
              font-size: 12px;
            }
          }
        }
      }
    }
  }

  .profile-dialog {
    .ui-scrollbar {
      margin: 0 -16px;
      padding: 16px;
      background-color: var(--Bg-02);
    }

    .ui-form-item .prepend {
      background-color: var(--Black-20);
    }
  }

  .global-sidebar .sidebar-scroll nav > ul > li > a i,
  .announcements-wrap .header-top > header,
  .tag-product-drawer .input-box > header h2,
  .tag-product-drawer .list-box .info-head .info h2,
  .home-page .section-left .summary-block h4,
  .message-sidebar,
  .add-brand-connect-list-box .el-collapse-item__header,
  .add-brand-connect-list-box .ui-collapse-item__header,
  .announcements-wrap .swiper,
  .announcements-block .swiper,
  .mobile-header .center .select-storefront .dropdown-trigger-image,
  .mobile-header .center .select-storefront .ui-dropdown svg,
  .analytics-header .left .ui-select,
  .analytics-header .left .arrow-icon,
  .global-sidebar .sidebar-srcoll nav > ul > li > a i,
  .global-sidebar .sidebar-srcoll nav .sub-menu-tigger,
  .global-sidebar .sidebar-srcoll nav .sub-menu-tigger + div {
    display: none !important;
  }

  .add-brand-connect-list-box .ui-collapse-item__wrap {
    display: block !important;
  }

  .tag-product-drawer .input-box > header .link {
    margin-top: 0;
  }

  .add-brand-connect-list-box .connect-box {
    padding: 0;
  }

  .connect-list-dialog .connect-box {
    padding: 0;
    background-color: transparent;
    gap: 8px;
    border-radius: 0px;

    .connect-line {
      padding: 8px 8px 8px 16px;
      border-radius: var(--radius);
      background-color: var(--Bg-03);
      cursor: pointer;
      transition: background-color 0.3s;
      position: relative;

      &:hover {
        background-color: var(--Black-20);
      }

      .ui-button::before {
        position: absolute;
        content: '';
        z-index: 3;
        top: 0%;
        left: 0%;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
  }
  
  .status-box {
    align-items: center;
  }

  .message-wrap {
    padding: 0;
    margin: 0;

    .message-header {
      border-bottom: 1px solid var(--Black-30);
      padding: 0 var(--padding);
      min-height: 63px;

      .ui-image,
      h1 {
        opacity: 0;
      }
    }

    .message-content  {
      background-color: var(--Bg-02);
    }

    .message-content .message-list {
      padding: 24px var(--padding);
      background-color: var(--Bg-02);
    }

    .message-alert {
      padding-left: var(--padding);
      padding-right: var(--padding);
    }

    .message-footer {
      padding: 16px var(--padding);
    }
  }

  .home-page .ui-slider .ui-slider__bar {
    background-color: var(--Yellow-30);
  }

  .empty-content{
    .con-title,
    p{
      color: var(--Text-primary);
    }

    .content-text-box {
      gap:34px;
    }
  }

}

.ui-picker-panel__shortcut{
  text-transform: uppercase;
}


.profile-data-select-picker {
  .ui-picker-panel__icon-btn.d-arrow-right,
  .d-arrow-left.ui-picker-panel__icon-btn,
  .ui-date-picker__header > span:nth-child(2) {
    display: none !important;
  }
}



body {

  .manage-header {
    margin: 16px 0;
    display: flex;
    align-items: center;
    gap: 12px;

    h2 {
      font: var(--demi-24);
      color: var(--Text-primary);
    }

    .search-trigger {
      background-color: transparent;

      &:hover {
        background-color: var(--Bg-03);
      }
    }

    .favorited-filter {
      margin-left: auto;
    }
  }

  .manage-page-header {
    box-shadow: unset;
    height: 63px;
    border-bottom: 1px solid var(--Black-30);

    &::before,
    &::after {
      display: none;
    }

    .mobile-button {
      display: none;
    }

    h1 {
      span {
        display: flex;
        align-items: center;
      }

      i {
        color: var(--Text-default);
        cursor: pointer;
        display: block;
        margin-left: 6px;

        svg {
          width: 18px;
          height: 18px;
        }

        &:hover {
          color: var(--Text-brand);
        }
      }
    }

    .alert-text {
      display: flex;
      margin-left: 16px;
    }



    @media screen and (max-width: $mobile_size) {
      padding: 0 16px;
      height: var(--mobile-header-height);
      min-height: unset;
      position: fixed;
      top: 0;
      z-index: 109;
      background-color: transparent;
      box-shadow: none;
      width: 100%;
      pointer-events: none;
      border: none;

      .alert-text {
        display: none;
      }
      
      &::before,
      &::after {
        display: none;
      }

      .mobile-button {
        padding: 0;
        display: block;
        pointer-events: auto;

        svg {
          height: 18px;
          width: 18px;

          &.svg-icon__eye {
            width: 20px;
            height: 20px;
          }

          &.svg-icon__home {
            width: 22px;
            height: 22px;
          }
        }

        &.mobile-home-btn {
          height: 40px;
          width: 40px;
          position: relative;
          left: -10px;
        }

        &.archived-btn {
          position: relative;
          height: 40px;
          width: 40px;
          left: -16px !important;
        }

        &.mobile-share-btn {
          height: 40px;
          width: 40px;
          position: relative;
          right: -8px;
          margin-left: -4px !important;
        }
      }

      h1 {
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        
        
        & > span {
          font: var(--medium-16);
          padding-left: 6px;


          & > i {
            display: none;
          }
        }

      }
    }
  }

  .storefront-page-tabs {
    margin: 24px var(--padding) 0;

    &::before {
      display: none;
    }

    ul {
      border-radius: var(--radius);
      background-color: var(--Bg-03) !important;
      overflow: hidden;
    }


    ul li a {
      height: 48px;
      box-shadow: unset !important;
      border-radius: 0 !important;
      position: relative;
      background-color: transparent !important;
      font: var(--book-14) !important;
      text-transform: uppercase;
      color: var(--Text-primary);

      &:hover {
        background-color: var(--Bg-01) !important;
      }
    }

    ul li:last-child a::before {
      content: 'My';
      padding-right: 8px;
    }

    ul li.active a {
      background-color: var(--Bg-01) !important;
      border-radius: var(--radius) !important;
      border: 1px solid var(--Border-default);
    }

    @media screen and (max-width: $mobile_size) {
      margin: 0;

      ul {
        border-radius: 0;
        margin: 0;
        padding: 8px 12px;
      }
    }
  }

  .links-page .table-content-box,
  .links-page .links-filter-bar {
    padding-left: var(--padding);
    padding-right: var(--padding);
  }

  &.page-manage-links,
  &.page-manage {
    .ui-main {
      // margin-top: 0;
      // border-radius: unset;
      // box-shadow: none;
      // border-left: 1px solid var(--Black-30);
      display: grid;
      grid-template-rows: auto 1fr;
      background-color: var(--Bg-01);
      // height: 100vh;
    }

    @media screen and (max-width: $mobile_size) {
      background-color: var(--Bg-light);
    }


    .storefront-page-wrap {
      padding: 0 var(--Text-primary);
      width: 100%;
      background-color: var(--Bg-02) !important;

      @media screen and (max-width: $mobile_size) {
        padding: 0;
      }
    }


    .storefront-page {
      // min-height: 100%;
      background-color: transparent;
      box-shadow: unset;

      @media screen and (max-width: $mobile_size) {
        box-shadow: none;
      }
    }
  }

}

</style>
